import { useEffect, useRef } from "react";

/**
 * Reset pagination to pageIndex 0 when non-sort filter values change.
 * Extracted from Company `useCompanyData` (P3 parity).
 *
 * @param {Record<string, unknown>} queryParams
 * @param {{ pageIndex: number, pageSize: number }} pagination
 * @param {Function} setPagination
 */
export function usePaginationReset(queryParams, pagination, setPagination) {
  const prevQueryParamsRef = useRef({});

  useEffect(() => {
    const currentFilters = Object.entries(queryParams || {}).filter(
      ([key]) => key !== "sort"
    );
    const prevFilters = Object.entries(prevQueryParamsRef.current).filter(
      ([key]) => key !== "sort"
    );

    const filtersChanged =
      currentFilters.length !== prevFilters.length ||
      currentFilters.some(
        ([key, val]) => prevQueryParamsRef.current[key] !== val
      );

    if (filtersChanged && pagination.pageIndex !== 0) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: 0,
      }));
    }

    prevQueryParamsRef.current = queryParams || {};
  }, [queryParams, pagination.pageIndex, setPagination]);
}
